import { createSelector } from 'reselect'
import moment from "moment";
import { NEXTS_NEED_COMMENT_FILTER_KEY } from "../utils/toggle";


const SHOW_MORE_KEY  = 'next_show_more';

const getNexts = state => state.m.nexts
const getCurrentSort = state => {
  const raw = state.ui.sort['nexts'];
  if (!raw) return {key: 'name', dir: 'asc'};
  if (typeof raw === 'string') return {key: raw, dir: 'asc'}; // rétro-compat ancien format
  return raw;
}
const getShowMoreKey = state => state.ui.toggle[SHOW_MORE_KEY]
const getNeedCommentFilter = state => !!state.toggle[NEXTS_NEED_COMMENT_FILTER_KEY]
const getTimespentByPacker = state => (state.m.packerstattimespent && state.m.packerstattimespent.by_packer) || {}

const iph7d = (timespent_by_packer, uid) => (timespent_by_packer[uid] || {}).iph_7d || 0;
const packingSeconds7d = (timespent_by_packer, uid) => (timespent_by_packer[uid] || {}).packing_seconds_7d || 0;
const stockpillingSeconds7d = (timespent_by_packer, uid) => (timespent_by_packer[uid] || {}).stockpilling_seconds_7d || 0;

export const getSortedFilteredNexts = createSelector(
  [getNexts, getCurrentSort, getShowMoreKey, getTimespentByPacker, getNeedCommentFilter],
  (nexts, currentSort, showMoreKey, timespent_by_packer, needCommentFilter) => {
    // 0-0 : ??
    // 31-0 : stop
    const beginOfDay = moment().startOf('day');
    const mult = currentSort.dir === 'desc' ? -1 : 1;
    return nexts.filter(p => p.current_task_type !== '31-0' && p.current_task_type !== '0-0')
      .filter(p => moment(p.last_started_at) > beginOfDay)
      .filter(p => !needCommentFilter || (p.user && p.user.is_comment_count_warning))
      .sort((a, b ) => {
        if (currentSort.key === 'name') {
          if (a.user.is_working === b.user.is_working) {
            return mult * (a.user.name <= b.user.name ? -1 : 1);
          }
          return (a.user.is_working ? -1 : 1); // stratification métier, non inversée
        }
        if (currentSort.key === 'duration') {
          // durée = now - last_started_at ⇒ asc = plus courte d'abord
          return mult * (moment(b.last_started_at).valueOf() - moment(a.last_started_at).valueOf());
        }
        if (currentSort.key === 'iph_7d') {
          return mult * (iph7d(timespent_by_packer, a.user.id) - iph7d(timespent_by_packer, b.user.id));
        }
        if (currentSort.key === 'time_packing_7d') {
          return mult * (packingSeconds7d(timespent_by_packer, a.user.id) - packingSeconds7d(timespent_by_packer, b.user.id));
        }
        if (currentSort.key === 'time_stockpilling_7d') {
          return mult * (stockpillingSeconds7d(timespent_by_packer, a.user.id) - stockpillingSeconds7d(timespent_by_packer, b.user.id));
        }
        return mult * (a.current_task_type <= b.current_task_type ? -1 : 1);
      })
      .filter(p => p.user.has_planning || showMoreKey);
  }
)
